<template>
<modal name="adtop-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>
  <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="permissionType == 2">
    <p style="font-size: 120%;">転職活動の準備ができているか<br>チェックリストを確認してね！</p>
    <br/>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >履歴書・職歴書の書き方、本当に大丈夫？
      </p>
    </div>
    <br/>
    <div class="text-center">
      <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
      onClick="window.open('https://bit.ly/3aGWmcW', '_blank');" ><span>落ちる人の書き方を確認</span></button>
      <!-- https://bit.ly/3aGWmcW -->
    </div>
    <br/>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >退職手続き終わっていますか？
      </p>
    </div>
    <br/>
    <div class="text-center">
      <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
      onClick="window.open('https://bit.ly/3uT6SV6', '_blank');" ><span>心配な人は詳細を確認</span></button>
    </div>
    <br/>
  </div>
  <div class="setting" v-else-if="permissionType == 3">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 120%;" v-if="false">＼東京23区のお仕事限定!!／</p>
      <p style="font-size: 120%;">今作成した履歴書をもとに<br>プロがあなたにおススメの<br>{{baite_title}}先をご紹介します!!</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/mynabi_logo.png" style="width:100%" >
        </p>
      </div>
      <p style="font-size: 120%;">同意するにチェックいただいた方には<br>「マイナビアルバイト紹介サービス」から<br>メールor電話にてご連絡させていただきます。</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <el-checkbox v-model="isAgree" style="-moz-transform:scale(1.4);-webkit-transform:	scale(1.4);transform:scale(1.4);">10分程度の無料相談を受けたい方はこちら</el-checkbox>
        </p>
      </div>
      <br/>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          株式会社マイナビ アルバイト紹介サービス<a href="https://baito.mynavi.jp/user/html/kiyaku.html#tab5" target="_blank">利用規約</a>、<a href="https://baito.mynavi.jp/user/html/privacy.html#tab5" target="_blank">個人情報の取り扱いについて</a>
          <br/>Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針について</router-link>
        </p>
      </div>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false"
          style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
          @click="$eventHub.$emit('send-mynabi-consult');">同意する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
         style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br/>
      <div class="text-center" v-if="false">
        <el-button id="send-adtop-pdf" type="success"
          @click="$eventHub.$emit('send-adtop-scout');closeDialog();">全てに同意してスカウトを直接受け取る</el-button>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
        無料相談が必要ない方はこちら
      </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == false" type="primary" @click="closeDialog();">同意しない</el-button>
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == true" type="primary" @click="closeDialog();">閉じる</el-button>
      </div>
    </div>
  </div>
  <div class="setting" v-else-if="permissionType == 4">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 120%;">転職活動の準備ができているか<br>チェックリストを確認してね！</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >履歴書・職歴書の書き方、本当に大丈夫？
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://bit.ly/3aGWmcW', '_blank');" ><span>落ちる人の書き方を確認</span></button>
        <!-- https://bit.ly/3aGWmcW -->
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >退職手続き終わっていますか？
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://bit.ly/3uT6SV6', '_blank');" ><span>心配な人は詳細を確認</span></button>
      </div>
    </div>
  </div>
  <div class="setting" v-else-if="permissionType == 9">
    <div class="setting-item" style="text-align:center;">
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/bnr/popup_banner_intern_20220729.png" style="width:100%" >
        </p>
      </div>
      <br/>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="font-size: 120%;background-color:#E3165C;border-color:#E3165C;"
        onClick="window.open('https://blog.yagish.jp/entry/2022/07/12/062308?utm_source=blogWidget', '_blank');" ><span>応募する</span></button>
      </div>
    </div>
  </div>
  <div class="setting" v-else-if="permissionType == 10" >
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
      <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/jigen_adtop_yagish_logo.png" style="width:90%" >
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">ご同意いただいた方には追って連絡がいき</p>
        <p style="font-size: 140%;">ますので、ご確認お願いいたします！</p>
      </div>
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link>
        <br/>
        アルバイトEXの<a href="https://arubaito-ex.jp/terms" target="_blank">利用規約</a>、<a href="https://arubaito-ex.jp/privacy" target="_blank">個人情報保護方針</a>
        <br/>
        ㈱アド・トップの<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報保護方針</a>
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意して無料相談や<br>求人受取、会員登録を希望する
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
      <p style="font-size: 140%;"> 
        <el-checkbox v-model="isAgree" style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して無料相談や<br>求人受取、会員登録を希望する</el-checkbox>
      </p>
      <br/>
    </div>
    <div class="text-center">
      <el-button id="send-adtop-pdf" type="success" v-if="isSended == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 120%;" 
        @click="$eventHub.$emit('send-adtop-consult');">正社員希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
        @click="closeDialog();">送信しました</el-button>
      <br/>
    </div>
      <br/>
    <div class="text-center">
      <el-button id="send-adtop-pdf" type="success" v-if="isSendedJigen == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 120%;"
        @click="$eventHub.$emit('send-jigen-consult');">時短やアルバイト希望</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isSendedJigen == true"
        @click="closeDialog();">送信しました</el-button>
      <br/>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <br/>
      <br/>
      <p style="font-size: 140%;">退職で困っている人は無料で相談に乗るよ！</p>
      <p style="font-size: 140%;">退職関係なら法律にも詳しいよ！</p>
    </div>
    <div class="text-center">
      <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
      onClick="window.open('https://bit.ly/3uT6SV6', '_blank');" ><span>無料で質問する</span></button>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
      </p>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
      </div>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
      </p>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
      </div>
    </div>
  </div>
  <div class="setting" v-else>
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 120%;">ダウンロード・PDF送信が完了しました！</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px" >今作成した情報をもとにあなたに合った求人紹介を受けてみたい方
        </p>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針について</router-link>
          <br/>
          ㈱アド・トップの転職支援サービス<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報の取り扱いについて</a>
        </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false" style="background-color:#0F9934;border-color:#0F9934;"
          @click="$eventHub.$emit('send-adtop-consult');">規約に同意して無料相談する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <div class="text-center" v-if="false">
        <el-button id="send-adtop-pdf" type="success" style="background-color:#0F9934;border-color:#0F9934;"
          @click="$eventHub.$emit('send-adtop-scout');closeDialog();">全てに同意してスカウトを直接受け取る</el-button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
        ・無料相談は順次にご連絡をさせて頂きます。<br/>少々お時間いただきますので予めご了承ください。
      </p>
      </div>
      <div class="text-center">
        <el-button id="send-adtop-pdf" v-if="isSended == false" type="primary" @click="closeDialog();">無料相談しない</el-button>
        <el-button id="send-adtop-pdf" v-if="isSended == true" type="primary" @click="closeDialog();">閉じる</el-button>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >今作成した履歴書・職歴書の無料添削アドバイスを受けてみたい方
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://bit.ly/3aGWmcW', '_blank');" ><span>詳細を確認</span></button>
        <!-- https://bit.ly/3aGWmcW -->
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >退職手続き終わっていますか？
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://bit.ly/3uT6SV6', '_blank');" ><span>詳細を確認</span></button>
      </div>
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSended:false,
      isSendedJigen:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:true
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openAdtopDialog: function (id, html) {
      console.error('Adtop openDialog')
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('adtop-dialog')
      this.clearLocalStorageConfirmVisible = false
      if (id == "rirekisho_job_change" || id == "rirekisho_job_change2" || id == "rirekisho_nophoto_double" || id == "rirekisho_nophoto") {
        this.permissionType = 10
      } else if (id == "rerekisho_part_time" || id == "rirekisho_part_time2") {
        this.permissionType = 10
        if (id == "rirekisho_part_time2") {
          this.baite_title = 'パート'
        }
      } else if (id == "rirekisho_single") {
        this.permissionType = 10
      } else if (id == "shokumukeirekisho") {
        this.permissionType = 4
      } else if (id == "internship") {
        this.permissionType = 9
      }

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'adtop_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', '')
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeDialog: function () {
      this.$modal.hide('adtop-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendAdtopConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'adtop_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたに電話・メールでご連絡することがあります！`,
            type: 'error'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendMynabiConsult: async function () {
      console.log(this.username);
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'adtop_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.mynabiPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスにスカウトが届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendAdtopScout: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'adtop_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('reqflg', '1')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスにスカウトが届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
        })
    },
    sendCocorowaConsult: async function () {
      console.log(this.username);
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'adtop_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.cocorowaPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスにスカウトが届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendJigenConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const jigen_url = 'https://arubaito-ex.jp/search?kw=&form_type=header_search&ref_code=oem_register_yagish_link&utm_source=register_yagish_link&utm_medium=oem'
      window.open(jigen_url, '_blank')
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'adtop_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendJigen, formData, {timeout: 60000})
        .then(function (response) {
          app.isSendedJigen = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-jigen-consult', this.sendJigenConsult)
    this.$eventHub.$on('send-mynabi-consult', this.sendMynabiConsult)
    this.$eventHub.$on('send-adtop-consult', this.sendAdtopConsult)
    this.$eventHub.$on('send-adtop-scout', this.sendAdtopScout)
    this.$eventHub.$on('open-adtop-dialog', this.openAdtopDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-jigen-consult', this.sendJigenConsult)
    this.$eventHub.$off('send-mynabi-consult', this.sendMynabiConsult)
    this.$eventHub.$off('send-adtop-consult', this.sendAdtopConsult)
    this.$eventHub.$off('send-adtop-scout', this.sendAdtopScout)
    this.$eventHub.$off('open-adtop-dialog', this.openAdtopDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
